@let variant = this.variant();
@let color = variant === 'black' ? '#121212' : '#FFF9F5';
@let logo = this.logo();

@defer (on viewport; prefetch on idle) {
  @if (logo) {
    <core-qrcode
      [content]="content()"
      [size]="size()"
      [logo]="{
        src: logo,
        borderWidth: 1,
        borderRadius: 60,
        logoRadius: 20
      }"
      [dots]="{
        type: 'square',
        color: color,
      }"
      [corners]="{
        type: 'square',
        color: color,
        radius: {
          inner: 400,
          outer: 0
        }
      }"
    />
  } @else {
    <core-qrcode
      [content]="content()"
      [size]="size()"
      [dots]="{
        type: 'square',
        color: color,
      }"
      [corners]="{
        type: 'square',
        color: color,
        radius: {
          inner: 400,
          outer: 0
        }
      }"
    />
  }

} @placeholder (minimum 500ms) {
  <svg
    class="placeholder"
    [style.color]="color"
    width="800"
    height="800"
    fill="currentColor"
    viewBox="0 0 512 512"
  >
    <rect x="336" y="336" width="80" height="80" rx="8" ry="8"/>
    <rect x="272" y="272" width="64" height="64" rx="8" ry="8"/>
    <rect x="416" y="416" width="64" height="64" rx="8" ry="8"/>
    <rect x="432" y="272" width="48" height="48" rx="8" ry="8"/>
    <rect x="272" y="432" width="48" height="48" rx="8" ry="8"/>
    <rect x="336" y="96" width="80" height="80" rx="8" ry="8"/>
    <rect x="288" y="48" width="176" height="176" rx="16" ry="16"
          style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"/>
    <rect x="96" y="96" width="80" height="80" rx="8" ry="8"/>
    <rect x="48" y="48" width="176" height="176" rx="16" ry="16"
          style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"/>
    <rect x="96" y="336" width="80" height="80" rx="8" ry="8"/>
    <rect x="48" y="288" width="176" height="176" rx="16" ry="16"
          style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"/>
  </svg>
}
